const handleCheckedIcon = (disabled = false, error = false, theme) => {
    if (disabled)
        return theme.colors.ui04;
    if (error)
        return theme.colors.supportError01;
    return theme.colors.ui01;
};
const handleCheckedBorder = (disabled = false, error = false, theme) => {
    if (disabled)
        return theme.colors.ui03;
    if (error)
        return theme.colors.supportError01;
    return theme.colors.interactivePrimary01;
};
const handleCheckedBackground = (disabled = false, error = false, theme) => {
    if (disabled)
        return theme.colors.disabled01;
    if (error)
        return theme.colors.ui01;
    return theme.colors.interactivePrimary01;
};
const handlePressed = (disabled = false, error = false, theme, radio = false) => {
    if (disabled || error)
        return '';
    return `
      &:hover:active${radio ? '::before' : ' .checkbox-control'} {
          background:  ${theme.colors.interactivePrimary03};
          border-color: ${theme.colors.interactivePrimary03};
      }`;
};
export { handleCheckedBackground, handleCheckedBorder, handleCheckedIcon, handlePressed };
//# sourceMappingURL=InputRadioCheckbox.helpers.js.map